import { InjectionToken } from '@angular/core';

export interface SsrRequestContext {
  headers?: {
    host?: string;
  };
}

export const REQUEST = new InjectionToken<SsrRequestContext>('REQUEST');
